import { FC } from "react";
import { Author, singleNewsOverviewTypes } from "../../types/NewsTypes";
import { Flex, Box, Avatar, Text, Card, Skeleton } from "@radix-ui/themes";
import DateObject from "react-date-object";
import { locale_da } from "@/utils/constants/localeDanish";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import gregorian_en from "react-date-object/locales/gregorian_en";
import useSingleZone from "@/features/zones/hooks/useSingleZone";

export const SingleNewsMeta: FC<{
  data: singleNewsOverviewTypes & {
    author: Author;
  };
}> = ({ data }) => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const currentLang = currentUser.lang == "da" ? locale_da : gregorian_en;

  const { zoneItem, loading } = useSingleZone(data?.zone);

  const createdInMilliseconds =
    data.created.seconds * 1000 + data.created.nanoseconds / 1000000;
  const date = new DateObject({
    date: new Date(createdInMilliseconds),
    locale: currentLang,
  });

  const avatar = zoneItem ? zoneItem.imageURL : data.author?.profileLogoUrl;
  const fallback = zoneItem
    ? zoneItem.title.slice(0, 1)
    : data.author?.userName.slice(0, 1);
  const username = zoneItem ? zoneItem.title : data.author?.userName;

  return (
    <Skeleton loading={loading}>
      <Flex gap="3" direction="column">
        <Card>
          <Flex wrap="nowrap" gap="2" align="center" direction="row">
            <Avatar src={avatar} fallback={fallback} radius="full" size="3" />

            <Flex wrap="wrap" justify="center" direction="column">
              <Text as="p" mb="0" size="2" weight="bold" truncate>
                {username}
              </Text>
              <Text size="1" color="gray">
                {date.format("DD. MMMM YYYY, HH:mm:ss")}
              </Text>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </Skeleton>
  );
};
